<template>
    <div>
        <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{paddingTop: 0, paddingBottom: '20px' }">
            <template #title>
				<h5 class="mb-0">Restaurant Detail</h5>
			</template>
            <a-form-model >
                <a-row type="flex" :gutter="24">
                    <a-col :span="24" :lg="8" class="mb-24">
                        <a-form-model-item class="mb-10"
                                        label="Restaurant Name"
                        >
                            <a-input v-model="restaurantName" disabled/>
                        </a-form-model-item>
                    </a-col>

                    <a-col :span="24" :lg="8" class="mb-24">
                        <a-form-model-item class="mb-10"
                                            label="Organization No"
                        >
                            <a-input v-model="organizationNumber" disabled/>
                        </a-form-model-item>
                    </a-col>

                    <a-col :span="24" :lg="8" class="mb-24">
                        <a-form-model-item class="mb-10"
                                            label="Type"
                        >
                            <a-input v-model="restaurantType" disabled/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row type="flex" :gutter="24">
                    <a-col :span="24" :lg="12" class="mb-24">
                        <a-form-model-item class="mb-10"
                                        label="Address"
                        >
                            <a-input v-model="address" disabled/>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="24" :lg="6" class="mb-24">
                        <a-form-model-item class="mb-10"
                                        label="City"
                        >
                            <a-input v-model="city" disabled/>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="24" :lg="6" class="mb-24">
                        <a-form-model-item class="mb-10"
                                        label="Post Number"
                        >
                            <a-input v-model="postNumber" disabled/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row type="flex" :gutter="24">
                    <a-col :span="24" :lg="8" class="mb-24">
                        <a-form-model-item class="mb-10"
                                        label="Phone Number"
                        >
                            <a-input v-model="phoneNumber" disabled/>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="24" :lg="16" class="mb-24">
                        <a-form-model-item class="mb-10"
                                        label="Home page"
                        >
                            <a-input v-model="homePage" disabled/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row type="flex" :gutter="24">
                    <a-col :span="24" :lg="8" class="mb-24">
                        <a-card style="width:200px">
                            <img :src="imageUrl" slot="cover"/>
                        </a-card>
                    </a-col>
                    <a-col :span="24" :lg="16" class="mb-24">
                        <a-form-model-item class="mb-10"
                                        label="Description"
                        >
                            <a-textarea v-model="description" disabled/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
        </a-card>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import ImageUploader from '../../components/image/ImageUploader.vue'

export default {

    components : {
        ImageUploader
    },
    computed : {
        ...mapState({
            restaurantName : state => state.restaurant.restaurant.restaurantName,
            restaurantType : state => state.restaurant.restaurant.restaurantType,
            organizationNumber : state => state.restaurant.restaurant.organizationNumber,
            description : state => state.restaurant.restaurant.description,
            homePage : state => state.restaurant.restaurant.homePage,
            postNumber : state => state.restaurant.restaurant.postNumber,
            address : state => state.restaurant.restaurant.address,
            city : state => state.restaurant.restaurant.city,
            phoneNumber : state => state.restaurant.restaurant.phoneNumber,
            imageUrl : state => state.restaurant.restaurant.imageUrl

        })
    },
    data() {
        return {

        }
    },

    methods : {
        handleReadyUpload() {

        }
    },
    async created () {
        await this.$store.dispatch('restaurant/getRestaurantProfileAction', {});
    }
}
</script>

<style>

</style>